// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__FNOLCPWizard__FNOLCPWizardContainer div[class*=wizardMain]{--gw-wizard-page-main-width:100%}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/gw-capability-fnol-cp-react/FNOLCPWizard.module.scss"],"names":[],"mappings":"AACE,iEACE,gCAAA","sourcesContent":[".FNOLCPWizardContainer {\n  div[class*=\"wizardMain\"] {\n    --gw-wizard-page-main-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"FNOLCPWizardContainer": "app__FNOLCPWizard__FNOLCPWizardContainer"
};
export default ___CSS_LOADER_EXPORT___;
